import { gql } from '@apollo/client';
import { PaymentReversalInfo, TaxTransactionSyncInfo } from '../fragments';

export default gql`
  query PaymentReversalOrder($id: ID) {
    order(id: $id) {
      id
      hexCode
      paymentState
      total
      paymentReversals {
        ...PaymentReversalInfo
      }
      taxTransactionSyncs {
        ...TaxTransactionSyncInfo
      }
    }
  }
  ${PaymentReversalInfo}
  ${TaxTransactionSyncInfo}
`;
